export default "__VITE_ASSET__Cp40Gb7f__"